<template>
  <div
    id="header"
    :class="{
      navBarWrapFixed: navBarFixed == true,
      initOpacityBg: isOpacity == true,
      scrollBg: scrollBgFlag == true,
    }"
  >
    <img src="../../assets/img/footer/logo.svg" alt="" v-if="logoShow"  class="leftLogo"/>
    <img src="../../assets/img/footer/logo2.svg" alt="" v-else  class="leftLogo"/>
    <!-- 移动端手机显示 -->
    <i
      class="el-icon-s-operation navIcon"
      :style="{ color: navColor }"
      @click="drawer = true"
    ></i>
    <el-drawer :visible.sync="drawer" :direction="direction" :modal="false">
      <el-menu
        :default-active="$route.path"
        class="el-menu-demo"
        :background-color="bgColor"
        :text-color="textColor2"
        router
        active-text-color="#02ADA4"
        @select="drawer = false"
      >
        <el-menu-item
          v-for="(item, i) in navList"
          :key="i"
          :index="item.name"
          >{{ item.navItem }}</el-menu-item
        >
      </el-menu>
    </el-drawer>

    <!-- pc大屏显示 -->
    <div class="rightNav">
      <el-menu
        :default-active="$route.path"
        class="el-menu-demo"
        mode="horizontal"
        :background-color="bgColor"
        :text-color="textColor"
        router
        active-text-color="#02ADA4"
      >
        <el-menu-item
          v-for="(item, i) in navList"
          :key="i"
          :index="item.name"
          >{{ item.navItem }}</el-menu-item
        >
      </el-menu>
      <!-- <div class="ES" @click="changeLang()">{{$i18n.locale == 'cn'?'EN':'中文'}}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      isOpacity: false,
      scrollBgFlag: true,
      direction: "rtl",
      drawer: false,
      navBarFixed: false,
      bgColor: "rgba(255,255,255,1)",
      textColor: "#333333",
      textColor2: "#333333",
      navColor: "#333333",
      activeIndex: "/home",
      logoShow: true,
    };
  },
  computed: {
     navList(){
         return [
            { name: "/home", navItem: this.$t('header.home') },
            { name: "/product", navItem: this.$t('header.product') },
            { name: "/case", navItem: this.$t('header.case') },
            { name: "/about", navItem: this.$t('header.about') },
            { name: "/system", navItem: this.$t('header.system') },
        ]
     } 
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.watchScroll);
    if (this.$route.name == "about") {
      this.bgColor = "rgba(255,255,255,0)";
      this.textColor = "#ffffff";
      this.navColor = "#ffffff";
      this.logoShow = false;
      this.isOpacity = true;
    }else{
        this.scrollBgFlag = true;
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.name == "about") {
          this.bgColor = "rgba(255,255,255,0)";
          this.textColor = "#ffffff";
          this.navColor = "#ffffff";
          this.isOpacity = true;
          this.logoShow = false;
          this.scrollBgFlag = false;
        } else {
          this.bgColor = "rgba(255,255,255,1)";
          this.textColor = "#333333";
          this.navColor = "#333333";
          this.isOpacity = false;
          this.scrollBgFlag = true;
          this.logoShow = true;
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //  当滚动超过 100 时，实现吸顶效果
      if (scrollTop > 100) {
        //关于页面，导航吸顶固定，不透明
        this.navBarFixed = true; //导航吸顶固定

        if (this.$route.name == "about") {
          this.isOpacity = false;
          this.scrollBgFlag = true;
          this.logoShow = true;
          this.bgColor = "rgba(255,255,255,1)";
          this.textColor = "#333333";
          this.navColor = "#333333";
        }
      } else {
        //关于页面，导航透明
        this.navBarFixed = false;

        if (this.$route.name == "about") {
            this.isOpacity = true;
          this.logoShow = false;
          this.scrollBgFlag = false;
          this.bgColor = "rgba(255,255,255,0)";
          this.textColor = "#ffffff";
          this.navColor = "#ffffff";
        }
      }
    },
    changeLang(){
        this.$i18n.locale = this.$i18n.locale == 'cn'?'en':'cn'
        sessionStorage['locale'] = this.$i18n.locale;
    }
  },
  components: {},
};
</script>

<style scoped lang="scss">
#header {
  width: 100%;
  height: 10rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14%;
  .navIcon {
    display: none;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    width: 80%;
  }
  .el-menu--horizontal > .el-menu-item {
    margin: 0 7%;
    padding: 0;
  }
  .el-menu-item {
    &:hover {
      background: none !important;
      color: #02ada4 !important;
    }
  }
  .el-menu-item.is-active {
    background-color: none !important;
  }
  .leftLogo {
    width: 18rem;
  }
  .rightNav {
    width: 70%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .ES {
      width: 4rem;
      height: 3rem;
      background: #333333;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      cursor: pointer;
      font-size: 1.4rem;
    }
  }
  /* 当浏览器的可视区域小于px */
  @media screen and (max-width: 1570px) {
    .el-menu.el-menu--horizontal {
      width: 100%;
    }
    .el-menu--horizontal > .el-menu-item {
        margin: 0 5%;
    }
    .leftLogo{
        width: 12rem;
    }
  }
  @media screen and (max-width: 1200px) {
    .rightNav {
      width: 80%;
    }
  }

  @media screen and (max-width: 580px) {
    .el-menu.el-menu--horizontal {
      width: 85%;
    }
    .el-menu--horizontal > .el-menu-item {
        margin: 0 1%;
    }
    .leftLogo{
        width: 10rem;
    }
  }


  @media screen and (max-width: 480px) {
    .rightNav {
      display: none;
    }
    .navIcon {
      display: block;
      font-size: 3.5rem;
    }
  }
}
@media screen and (max-width: 480px) {
  #header {
    height: 5rem;
    justify-content: space-between;
    padding: 0 2rem;
  }
}

.navBarWrapFixed {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.8);
}
.initOpacityBg {
  background: rgba(255, 255, 255, 0);
  position: absolute;
  z-index: 99;
  top: 0;
}
.scrollBg {
  background: #fff !important;
}

</style>

